import * as modalReducer from "../reducers/modalReducer";

export const {
  getIsModalOpen,
  getProps,
  getContent,
  getClearOnSubmit,
  getWidth,
  getIsViewOnly,
} = modalReducer;
